import { post } from '@rails/request.js'
import { Controller } from "@hotwired/stimulus"
import { Current } from "current.js";
import { ethers } from "ethers";

// Connects to data-controller="flexible-staking-item"
export default class extends Controller {
  static targets = ["startDate", "unlockDate", "totalBananaEarned", "unstakeBtn", "claimBtn"]

  async connect() {
    const somnia_chain_id = 5031
    this.nft_id = this.element.dataset.id;
    this.provider = new ethers.BrowserProvider(window.ethereum);
    this.signer = await this.provider.getSigner();
    this.nft = await this.#getNftContract()
    this.staking = await this.#getStakingContract()
    this.nft_data = await this.#getNftData()

    const network = await this.provider.getNetwork()
    this.is_wrong_chain = network.chainId != somnia_chain_id ? true : false

    if (this.is_wrong_chain) {
      toast('Wrong blockchain chain detected', { type: 'error', description: 'Please switch chain to Somnia Mainnet' })
      return;
    }

    this.startDateTarget.innerText = this.nft_data.startFormatted
    this.unlockDateTarget.innerText = this.nft_data.unlockFormatted

    this.#updateTotalBananaEarned()

    this.#checkUnstackable()

    this.banana_interval = setInterval(() => {
      this.#updateTotalBananaEarned()
    }, 2000);

    setTimeout(() => {
      this.#checkClaimable()
    }, 1000);
  }

  disconnect() {
    clearInterval(this.banana_interval)
  }

  async claim() {
    showLoading("Claiming Banana")

    const response = await post('/user/stake/claim', {
      body: JSON.stringify({ id: this.nft_id })
    })

    if (response.ok) {
      const { msg, status, desc } = await response.json
      toast(msg, { type: status, description: desc })
      setTimeout(() => { window.location.reload() }, 500);
    } else {
      toast("Oops something happened", { type: "error", description: "Please check your internet connection and refresh the page." })
    }

    hideLoading()
  }

  async unstake() {
    showLoading("Unstaking NFT")

    const response = await post('/user/stake/unstake', {
      body: JSON.stringify({ id: this.nft_id }),
      responseKind: "json"
    })

    if (response.ok) {
      const { msg, status, desc } = await response.json
      toast(msg, { type: status, description: desc })
      setTimeout(() => { window.location.reload() }, 500);
    } else {
      toast("Oops something happened", { type: "error", description: "Please check your internet connection and refresh the page." })
    }

    hideLoading()
  }

  async #getNftContract() {
    const nft_abi = [
      "function totalSupply() view returns (uint256)",
      "function balanceOf(address owner) view returns (uint256)",
      "function ownerOf(uint256 tokenId) view returns (address)",
      {
        inputs: [
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint256", name: "tokenId", type: "uint256" },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
    ];

    return new ethers.Contract(Current.address.nft, nft_abi, this.signer);
  }

  async #getStakingContract() {
    const staking_abi = [
      { inputs: [{ internalType: "uint256", name: "nftId", type: "uint256" }], name: "stake", outputs: [], stateMutability: "nonpayable", type: "function" },
      "function getUserStakes(address _user) view returns (uint256[] memory)",
      {
        inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        name: "stakes",
        outputs: [
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "uint64", name: "start", type: "uint64" },
          { internalType: "uint64", name: "unlock", type: "uint64" },
          { internalType: "uint128", name: "bananaClaimed", type: "uint128" },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "nftId", type: "uint256" }],
        name: "bananaPending",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
    ];

    return new ethers.Contract(Current.address.staking, staking_abi, this.signer);
  }

  async #getNftData() {
    const stake = await this.staking.stakes(BigInt(this.nft_id))
    const owner = stake[0]

    const start = stake[1]
    const startFormatted = new Date(parseInt(stake[1]) * 1000).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC'
    })

    const unlock = stake[2]
    const unlockFormatted = new Date(parseInt(stake[2]) * 1000).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC'
    })

    const claimed = stake[3]

    const block = await this.provider.getBlock("latest");
    if (BigInt(block.timestamp) >= unlock) {
      this.unstakeBtnTarget.disabled = false;
    }

    return { owner, start, startFormatted, unlock, unlockFormatted, claimed }
  }

  async #updateTotalBananaEarned() {
    const nft_data = await this.#getNftData()

    const tokenPerSecond = 25500000000000000;
    const block = await this.provider.getBlock("latest");
    const duration = BigInt(block.timestamp) - BigInt(nft_data.start);
    const gross = duration * BigInt(tokenPerSecond);
    const banana = gross - BigInt(nft_data.claimed);

    this.totalBananaEarnedTarget.innerText = ethers.formatEther(banana)
  }

  async #checkUnstackable() {
    const block = await this.provider.getBlock("latest");
    if (BigInt(block.timestamp) >= this.nft_data.unlock) {
      this.unstakeBtnTarget.disabled = false;
    }
  }

  async #checkClaimable() {
    const banana = parseFloat(this.totalBananaEarnedTarget.innerText)

    if (banana > 0) {
      this.claimBtnTarget.disabled = false;
    }
  }
}
